import React from "react";
import { Navigate } from "react-router-dom";
import { useSettings, useFanClub } from "../../contexts/AppContext";
import CartDrawer from "./CartDrawer";

export function LoadingSpinner() {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#080808] min-h-screen">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="hero-glow -top-40 -left-40 w-[500px] h-[500px] opacity-40" />
        <div className="absolute top-1/2 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
      </div>
      <div className="relative flex flex-col items-center gap-8 animate-fade-in">
        <img
          src="/assets/images/logo-tz.png"
          alt="Tajti Zoltán"
          className="w-20 h-20 sm:w-24 sm:h-24 object-contain drop-shadow-lg"
        />
        <div className="text-center">
          <h2 className="text-xl sm:text-2xl font-bold font-['Syne'] tracking-tight text-white">
            Tajti Zoltán
          </h2>
          <p className="text-xs sm:text-sm text-white/50 mt-1 tracking-widest uppercase">
            Betöltés...
          </p>
        </div>
        <div className="flex items-center justify-center gap-1.5 h-6">
          <span className="w-2 h-2 rounded-full bg-primary animate-[loading-dot_1.4s_ease-in-out_infinite_both]" style={{ animationDelay: "0s" }} />
          <span className="w-2 h-2 rounded-full bg-primary animate-[loading-dot_1.4s_ease-in-out_infinite_both]" style={{ animationDelay: "0.2s" }} />
          <span className="w-2 h-2 rounded-full bg-primary animate-[loading-dot_1.4s_ease-in-out_infinite_both]" style={{ animationDelay: "0.4s" }} />
        </div>
      </div>
    </div>
  );
}

export function ShopGuard({ children }) {
  const { shop_enabled, _loaded } = useSettings();
  if (!_loaded) return <LoadingSpinner />;
  return shop_enabled ? children : <Navigate to="/" replace />;
}

export function FanClubGuard({ children }) {
  const { fanclub_enabled, _loaded } = useSettings();
  if (!_loaded) return <LoadingSpinner />;
  return fanclub_enabled ? children : <Navigate to="/" replace />;
}

/** Fan Club be van kapcsolva ÉS a felhasználó be van lépve; különben /fan-club-ra irányít. */
export function FanClubMemberGuard({ children }) {
  const { fanclub_enabled, _loaded } = useSettings();
  const { member } = useFanClub();
  if (!_loaded) return <LoadingSpinner />;
  if (!fanclub_enabled) return <Navigate to="/" replace />;
  if (!member) return <Navigate to="/fan-club" replace />;
  return children;
}

export function ConcertsGuard({ children }) {
  const { concerts_enabled, _loaded } = useSettings();
  if (!_loaded) return <LoadingSpinner />;
  return concerts_enabled ? children : <Navigate to="/" replace />;
}

export function ConditionalCartDrawer() {
  const { shop_enabled } = useSettings();
  return shop_enabled ? <CartDrawer /> : null;
}
